import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { FormProvider as Form } from "react-hook-form";
// @mui
import { Stack } from "@mui/material";

// ----------------------------------------------------------------------

const FormProvider = forwardRef(({ id, children, onSubmit, methods, sx, style }, ref) => (
    <Form {...methods}>
        <Stack ref={ref} component="form" id={id}
               onSubmit={(e) => {
                   e.preventDefault(); // 阻止默认提交行为
                   e.stopPropagation(); // 阻止事件冒泡
                   //
                   onSubmit(e); // 调用 react-hook-form 的 handleSubmit
               }}
               sx={{ ...sx, ...style }}
        >
            {children}
        </Stack>
    </Form>
));

FormProvider.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node.isRequired,
    methods: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    sx: PropTypes.object,
    style: PropTypes.object
};

export default FormProvider;
